export default __webpack_public_path__ + "static/media/git.50214827.svg";